import {withRouter} from 'react-router';

import {getLink} from '@appComponents/Link';
import DefaultForm from '@appComponents/DefaultForm';

export class ContentCategoryForm extends DefaultForm {
    componentDidMount() {
        this.setCreateSuccessCallback((response) => {
            this.refreshData(response.data);
        });
        this.setUpdateSuccessCallback((response) => {
            this.refreshData(response.data);
        });
    }

    prepareDataForSubmit = (data) => {
        return {
            ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
            ...data,
            level: this.props.formParams.level,
            parent: this.props.formParams.parentId,
        };
    };

    renderErrors(errorData) {
        super.renderErrors(
            errorData,
            this.props.Model.label,
            getLink('content_categories.index'),
            {size: 'tiny'}
        );
    }

    refreshData = (data) => {
        this.props.formParams.refreshData(data);
    };

    renderDeleteButton = () => null;
}

export default withRouter(ContentCategoryForm);
